"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "monvalle": {
    "013eede6": [{
      "hkey": "db6d6a23",
      "slug": "monvalle",
      "name": "Monvalle",
      "primary": true,
      "skipSearch": false
    }],
    "bosco-grande": [{
      "hkey": "db6d6a23",
      "slug": "monvalle",
      "name": "Monvalle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "87463aee": [{
      "hkey": "aaf495e1",
      "slug": "turro-lido-di-monvalle",
      "name": "Turro-Lido di Monvalle",
      "primary": true,
      "skipSearch": false
    }],
    "lido-di-monvalle": [{
      "hkey": "aaf495e1",
      "slug": "turro-lido-di-monvalle",
      "name": "Turro-Lido di Monvalle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "monvalle"
    }],
    "fdf3ddf7": [{
      "hkey": "db6d6a23",
      "slug": "monvalle",
      "name": "Monvalle",
      "primary": true,
      "skipSearch": false
    }],
    "monvallina": [{
      "hkey": "db6d6a23",
      "slug": "monvalle",
      "name": "Monvalle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c536addb": [{
      "hkey": "db6d6a23",
      "slug": "monvalle",
      "name": "Monvalle",
      "primary": true,
      "skipSearch": false
    }],
    "piano-inferiore": [{
      "hkey": "db6d6a23",
      "slug": "monvalle",
      "name": "Monvalle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "23b5aa4c": [{
      "hkey": "db6d6a23",
      "slug": "monvalle",
      "name": "Monvalle",
      "primary": true,
      "skipSearch": false
    }],
    "piano-superiore": [{
      "hkey": "db6d6a23",
      "slug": "monvalle",
      "name": "Monvalle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e50d54ee": [{
      "hkey": "db6d6a23",
      "slug": "monvalle",
      "name": "Monvalle",
      "primary": true,
      "skipSearch": false
    }],
    "sassello": [{
      "hkey": "db6d6a23",
      "slug": "monvalle",
      "name": "Monvalle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b7189f7f": [{
      "hkey": "aaf495e1",
      "slug": "turro-lido-di-monvalle",
      "name": "Turro-Lido di Monvalle",
      "primary": true,
      "skipSearch": false
    }],
    "turro": [{
      "hkey": "aaf495e1",
      "slug": "turro-lido-di-monvalle",
      "name": "Turro-Lido di Monvalle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;